module.exports = __webpack_public_path__ + "static/media/logo-white.913650c8.png";